import {combineReducers} from 'redux'
import types from 'actions/types'

export const sharePointStatus = (state = null, action) => {
  switch (action.type) {
    case types.SHARE_POINT_DISABLE_SUCCESS:
    case types.SHARE_POINT_STATUS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  sharePointStatus,
})
